module.exports = __webpack_public_path__ + "img/namsan_gallery6.50d90a56.jpg";